module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBold.b80caec2.ttf";